import Vue from "vue";
import Router from "vue-router";
import Login from "@/login/detail/logindetail";
import First from "@/manage/first";
import GetData from '@/manage/GetData'
import axios from '@/js/axios.js'
import UpdatePage from '@/manage/UpdatePage'
import Change from '@/manage/Change'
import GetDataDetail from '@/manage/getdatadetail/GetDataDetail'
import YuYueManage from '@/manage/datapage/YuYueManage'
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/",
      component: First,
      children:[     
        {
          path:"getdata",
          name:'getdata',
          component:GetData
        },
        {
          path:"/",
          name:'getdata',
          component:GetData
        },
        {
          path:"getdatadetail",
          name:"getdatadetail",
          component:GetDataDetail
        },
        {
          path:"change",
          name:"change",
          component:Change
        },
        {
          path:"yuyuemanage",
          name:"yuyuemanage",
          component:YuYueManage
        }
      ]
    },

  ]
});

router.beforeEach((to, from, next) => {
  

  axios.post("/logins/qdlogins").then(data => {

    if (data.code == 200) {
      //校验成功的话,登录首页，也返回到后台页
      if (to.path == "/login") {

        next("");
      }
     

      next();
    } else {
      //校验失败的话，登录非首页，也返回到首页
     
      if (to.path != "/login") {
       
         next("/login");
      } else {
        next();
      }
    }
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js